/* 🤖 this file was generated by svg-to-ts */
export const matIconBrowseGallery: {
  name: 'browse-gallery';
  data: string;
} = {
  name: 'browse-gallery',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 3a9 9 0 1 0 .001 18.001A9 9 0 0 0 9 3zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/><path d="M10 7H8v5.41l3.79 3.8 1.42-1.42-3.21-3.2zm7.99-3.48v2.16A6.99 6.99 0 0 1 22 12c0 2.79-1.64 5.2-4.01 6.32v2.16C21.48 19.24 24 15.91 24 12s-2.52-7.24-6.01-8.48z"/></svg>`
};
